export default {
    // If updating this URL, ensure it works with CID updates in ./templates/index.js
    regLink : 'https://account.arena.net/register'
};
